module.exports = __webpack_public_path__ + "assets/img/img254.8e8636b6.png";